import axios from "axios";
import { getCookie } from "../getcookie";

const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
const isHttpsOnly = process.env.REACT_APP_HTTPS_ONLY === "true";

// Helper to build headers with a fresh token / cookie on each request.
const getHeaders = () => ({
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  ...(isHttpsOnly ? { "Access-Control-Allow-Origin": process.env.REACT_APP_ACCESS_CONTROL_ALLOW_ORIGIN } : {}),
  ...(!isHttpsOnly ? { Authorization: getCookie("mawalog") } : {}),
});

// Strip path-traversal / injection characters from a relative endpoint.
const validateEndpoint = (endpoint) => {
  if (!endpoint || typeof endpoint !== "string") return "";
  return endpoint.replace(/\.\./g, "").replace(/[<>"']/g, "");
};

export const apiCallAdmin = async (method, endpoint, data = null, options = {}) => {
  try {
    const safeEndpoint = validateEndpoint(endpoint);
    if (!safeEndpoint) {
      return { data: { success: false, message: "Invalid request endpoint" } };
    }

    const config = {
      method,
      // Absolute URLs pass through unchanged; relative paths get the admin base.
      url: safeEndpoint.startsWith("http") ? safeEndpoint : `${adminApiUrl}${safeEndpoint}`,
      withCredentials: isHttpsOnly,
      headers: getHeaders(),
      ...options,
    };
    if (data) {
      config.data = data;
    }

    const response = await axios(config);
    return response;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 401 && !endpoint.includes("login") && !endpoint.includes("sign_in")) {
        handleUnauthorized();
      }
      return error.response;
    } else if (error.request) {
      return { data: { success: false, message: "Network error. Please check your connection." } };
    } else {
      return { data: { success: false, message: "An error occurred. Please try again." } };
    }
  }
};

/**
 * Clears auth cookies and redirects to the accounts app on Unauthorized.
 */
export const handleUnauthorized = () => {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  document.cookie = "mawalog=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

  const currentURL = window.location.href;
  const redirectData = {
    redirectPath: currentURL,
    app: "accounts",
    ts: Date.now(),
  };

  // Tab-specific, cross-domain-safe redirect storage for post-login return.
  window.name = JSON.stringify(redirectData);
  window.location.href = `${accountsUrl}`;
};
